module.exports = __webpack_public_path__ + "img/ass_result_icon_result_conBg.335ee05e.png";